// reset-timer.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AutoLogoutService } from './auto-logout.service';
import { tap } from 'rxjs/operators';

export const resetTimerInterceptor: HttpInterceptorFn = (req, next) => {
    const autoLogout = inject(AutoLogoutService);

    return next(req).pipe(
        tap(() => {
            autoLogout.resetTimer(); // Timer bei jedem Request zurücksetzen
        })
    );
};
